var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "notification-preferences ctsform" }, [
            _vm.fetchingData && !_vm.componentDidIntitialFetch
              ? _c(
                  "div",
                  [
                    _c("v-progress-circular", {
                      staticClass: "circular-progress",
                      attrs: { indeterminate: "" }
                    })
                  ],
                  1
                )
              : _c("div", [
                  _vm.preferencesApplied &&
                  _vm.categories &&
                  _vm.categories.length
                    ? _c("div", [
                        !_vm.accountSummaryFlow
                          ? _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Notifications.PreferencesPage.Title")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "p",
                            { staticClass: "info-text acc_infomsg_default" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Notifications.PreferencesPage.InfoText"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isPhoneVerified
                            ? _c(
                                "p",
                                { staticClass: "info-text-phone" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { color: "blue", size: "16" }
                                    },
                                    [_vm._v("info")]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Notifications.PreferencesPage.Note"
                                      )
                                    )
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "categories-wrapper",
                            class: { all_3: _vm.supportedChannels.length === 3 }
                          },
                          [
                            _c("div", { staticClass: "table_head" }, [
                              _c("span", { staticClass: "title-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.Settings.Notifications.NotifyMe"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "channels" },
                                _vm._l(_vm.supportedChannels, function(
                                  channel,
                                  i
                                ) {
                                  return _c(
                                    "span",
                                    { key: i, staticClass: "channel" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.supportedDisplayChannels[
                                            channel
                                          ] || channel
                                        )
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.categories, function(category, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "category notifications-holder"
                                },
                                [
                                  _c("div", { staticClass: "category-name" }, [
                                    _vm._v(_vm._s(category.CategoryName))
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(category.Offers, function(offer, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "channel" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "offer-name" },
                                          [_vm._v(_vm._s(offer.OfferName))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "offer-channels" },
                                          _vm._l(
                                            offer.ChannelSubscriptions,
                                            function(subscription, i) {
                                              return _c("v-checkbox", {
                                                key: i,
                                                class: [
                                                  {
                                                    disabled:
                                                      subscription.Disabled
                                                  }
                                                ],
                                                attrs: {
                                                  disabled:
                                                    _vm.isProcessing ||
                                                    subscription.Disabled
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.editPreference({
                                                      OfferId: offer.OfferId,
                                                      Channel:
                                                        subscription.Channel,
                                                      Operation: subscription.active
                                                        ? "ACTIVATE"
                                                        : "DEACTIVATE"
                                                    })
                                                  }
                                                },
                                                model: {
                                                  value: subscription.active,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      subscription,
                                                      "active",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "subscription.active"
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary-btn",
                                attrs: {
                                  disabled:
                                    _vm.isProcessing ||
                                    !_vm.allowAccountUpdate ||
                                    _vm.updatedPreferences.length === 0,
                                  color: "success"
                                },
                                on: { click: _vm.save }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Notifications.PreferencesPage.Button.Save"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "secondary-btn",
                                attrs: {
                                  disabled:
                                    _vm.isProcessing || !_vm.allowAccountUpdate,
                                  color: "error",
                                  title: _vm.$t(
                                    "Notifications.PreferencesPage.Button.Reset.Tooltip"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.reset2Defaults()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Notifications.PreferencesPage.Button.Reset"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _c("div", [
                        _c(
                          "p",
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { color: "blue", size: "16" }
                              },
                              [_vm._v("info")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Notifications.PreferencesPage.NoOptionsAvailable"
                                )
                              )
                            )
                          ],
                          1
                        )
                      ])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Text"
            ),
            successText: _vm.$t("Account.PersonalDetails.Dialog.Success.Text"),
            errorTitle: _vm.$t("Account.PersonalDetails.Dialog.Error.Title"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.PersonalDetails.Dialog.Error.Text")
                        )
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "response-error" }, [
              _vm._v(_vm._s(_vm.transactionError))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.PersonalDetails.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d901310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d901310","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/NotificationPreferencesV2.vue
// module id = null
// module chunks = 